import React from 'react'
import { ArrowRightIcon, SparklesIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../interaxDesignSystemComponents'
import { TESTIDS } from '../../../../config/testids'
import { PlatformTourCard } from './PlatformTourCard'

interface PlatformTourWelcomeProps {
  name: string
  stopCount: number
  onStart: () => void
  onLater: () => void
}

/** Before the first stop: what the tour is and how long it takes. */
export const PlatformTourWelcome: React.FC<PlatformTourWelcomeProps> = ({ name, stopCount, onStart, onLater }) => {
  const { t } = useTranslation()

  return (
    <PlatformTourCard
      icon={<SparklesIcon />}
      title={t('gamer.platformTour.welcomeTitle', { name })}
      body={t('gamer.platformTour.welcomeBody', { count: stopCount })}
    >
      <Button
        variant="primary"
        icon={<ArrowRightIcon className="w-4 h-4" />}
        iconPosition="right"
        onClick={onStart}
        data-testid={TESTIDS.PLATFORM_TOUR_START_BTN}
      >
        {t('gamer.platformTour.startTour')}
      </Button>
      <Button variant="secondary" onClick={onLater} data-testid={TESTIDS.PLATFORM_TOUR_MAYBE_LATER_BTN}>
        {t('gamer.platformTour.maybeLater')}
      </Button>
    </PlatformTourCard>
  )
}
